import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TSuggest } from 'feature/registration/types'

interface CompanyAddressSliceState {
  input: string
  inputSuggest: TSuggest | null
  suggests: TSuggest[]
  isLoadingSuggest: boolean
  isError: boolean
  errorMessage: string
  isValid: boolean
  isDirty: boolean
}

const getInputSuggest = () => {
  const session = sessionStorage.getItem('companyInputSuggest')
  return session ? JSON.parse(session) : null
}

const initialState: CompanyAddressSliceState = {
  input: '',
  inputSuggest: getInputSuggest(),
  suggests: [],
  isLoadingSuggest: false,
  isError: false,
  errorMessage: '',
  isValid: false,
  isDirty: false,
}

const CompanyAddressSlice = createSlice({
  name: 'companyAddress',
  initialState,
  reducers: {
    setInputAddress: (state, action: PayloadAction<string>) => {
      state.input = action.payload
    },
    setInputAddressSuggest: (state, action: PayloadAction<TSuggest>) => {
      state.inputSuggest = action.payload
      sessionStorage.setItem(
        'companyInputSuggest',
        JSON.stringify(action.payload),
      )
    },
    setSuggests: (state, action: PayloadAction<TSuggest[]>) => {
      state.suggests = action.payload
    },
    clearInputAddress: (state, _action: PayloadAction<void>) => {
      state.suggests = []
      state.inputSuggest = null
      state.input = ''
      state.isValid = false
    },
    setIsLoadingSuggest: (state, action: PayloadAction<boolean>) => {
      state.isLoadingSuggest = action.payload
    },
    clearAddress: (state, _action: PayloadAction<void>) => {
      state.input = ''
      state.inputSuggest = null
      state.isError = false
      state.errorMessage = ''
      state.isDirty = false
      state.isValid = false
      state.suggests = []
    },
    setIsValidAddress: (state, action: PayloadAction<boolean>) => {
      state.isValid = action.payload
    },
    setIsDirtyAddress: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload
    },
    setIsError: (state, action: PayloadAction<boolean>) => {
      state.isError = action.payload
    },
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload
    },
  },
})

export const {
  actions: companyAddressActions,
  reducer: companyAddressReducer,
} = CompanyAddressSlice
